import { render, staticRenderFns } from "./therm-v2-ticket-details.vue?vue&type=template&id=a9409e10"
import script from "./therm-v2-ticket-details.vue?vue&type=script&lang=js"
export * from "./therm-v2-ticket-details.vue?vue&type=script&lang=js"
import style0 from "./therm-v2-ticket-details.vue?vue&type=style&index=0&id=a9409e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports